module.exports = __webpack_public_path__ + "static/media/hands.902d1334.png";